module.exports = __webpack_public_path__ + "static/media/TenancyProgression.33b17771.svg";